export default {
  removeWhite: {
    id: 0,
    title: `Удаление белого фона`,
    name: `removeWhite`
  },
  removeBlack: {
    id: 9,
    title: `Удаление чёрного фона`,
    name: `removeBlack`
  },
  grayscale: {
    id: 1,
    title: `Черно-белое`,
    name: `grayscale`
  },
  invert: {
    id: 2,
    title: `Инвертирование (негатив)`,
    name: `invert`
  },
  sepia: {
    id: 3,
    title: `Сепия`,
    name: `sepia`
  },
  brightness: {
    id: 4,
    title: `Яркость`,
    name: `brightness`
  },
  blur: {
    id: 5,
    title: `Размытость`,
    name: `blur`
  },
  sharpen: {
    id: 6,
    title: `Резкость`,
    name: `sharpen`
  },
  emboss: {
    id: 7,
    title: `Рельеф`,
    name: `emboss`
  },
  noise: {
    id: 8,
    title: `Шум`,
    name: `noise`
  },
  pixelate: {
    id: 10,
    title: `Пикселированность`,
    name: `pixelate`
  }
};
